import { memo } from 'react';

import classNames from 'classnames';
import { useRole } from 'hooks/useRole';

import { isMediaAffiliate } from 'utils/roles';

import RoleContentController from 'components/RoleContentController/RoleContentController';
import Typography from 'components/UI/Typography/Typography';

import { ROLES } from 'config/organization';

import styles from './TopBanner.module.scss';

const TopBanner = () => {
  const role = useRole();

  return (
    <div
      className={classNames(styles.root, {
        [styles.media]: isMediaAffiliate(role),
      })}
    >
      <Typography type="heading-md" weight="semibold" color="white">
        <RoleContentController
          roles={[ROLES.defaultUser, ROLES.mediaAffiliate]}
        >
          {['B2B Reward System', 'Affiliate Reward System']}
        </RoleContentController>
      </Typography>
      <Typography color="white">
        <RoleContentController
          roles={[ROLES.defaultUser, ROLES.mediaAffiliate]}
        >
          {[
            'Grow your business together with Evoplay!',
            'Engage with our games, drive traffic to your website, complete your season KPI tasks and get a chance to win rewards!',
          ]}
        </RoleContentController>
      </Typography>
    </div>
  );
};

export default memo(TopBanner);
